import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../data/store";
import { useDepotFilter } from "../filters/useDepotFilter";

import { ReportPrinter } from "./ReportPrinter";
import moment from "moment";
import { Data, VehicleFilter } from "../pages/nomenclatures/useVehiclesList";

export function usePrintVehiclesPdfExporterer() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDone, setIsDone] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);

  const selectedAutoColumn = useSelector(
    (state: RootState) => state.filters.selectedAutoColumn
  );
  const { depots, selectedDepot } = useDepotFilter();

  const exportPdf = useCallback(
    async (rows: Data[], filter: VehicleFilter | null) => {
      setIsDone(false);
      setHasError(false);
      setIsLoading(true);

      try {
        const printer = new ReportPrinter();
        printer.printSpace(5);

        printer.setFont("bold", 18, 1.2);
        printer.printText(
          `Списък на превозните средства към дата ${moment().format("LL")}`
        );

        printer.setFont("italic", 12, 1.2);
        printer.printText(
          `Гараж ${depots.find((d) => d.id === selectedDepot)?.value || "?"}`
        );

        if (filter) {
          printer.setFont("italic", 12, 1.2);
          printer.printText(
            `Филтър:
            ${filter.vehicle_id ? `Номер: ${filter.vehicle_id}` : ""} ${
              filter.autocolumn ? `Автоколона: ${filter.autocolumn}` : ""
            } ${filter.vehicle_type ? `Тип: ${filter.vehicle_type}` : ""} ${
              filter.periodic_tech_test
                ? `Периодичен технически преглед: ${filter.periodic_tech_test}`
                : ""
            }`
          );
        }

        printer.printSpace(15);

        printer.autoTable({
          styles: {
            halign: "left",
            valign: "top",
            font: "Roboto",
            fontSize: 9,
            cellPadding: 4,
            lineColor: [0, 0, 0],
            lineWidth: 0.25,
            //lineWidth: 0,
          },
          bodyStyles: {
            cellPadding: 4,
          },

          headStyles: {
            halign: "center",
          },
          columnStyles: {
            0: { cellWidth: 65, halign: "center" },
            1: { cellWidth: 65, halign: "center" },
            2: {
              halign: "center",
              // cellWidth:
              //   (printer.printableWidth - (45 + 20 + 45 + 45 + 45 + 45)) / 2,
            },
            3: { halign: "center" },
            4: { halign: "center" },
            5: { halign: "center" },
          },
          body: rows as any,
          columns: [
            {
              dataKey: "vehicle_id",
              header: "Номер",
            },
            {
              dataKey: "autocolumn",
              header: "Автоколона",
            },
            {
              dataKey: "vehicle_type",
              header: "Тип",
            },
            {
              dataKey: "periodic_tech_test",
              header: "Периодичен технически преглед",
            },
          ],
        });

        printer.save(
          `Списък превозни средства-${
            depots.find((d) => d.id === selectedDepot)?.value || "-"
          }-${selectedAutoColumn}-${moment().format("YYYY-MM-DD-HH-mm-ss")}.pdf`
        );
      } catch (err) {
        console.error("Cannot export into PDF:", err);
        setHasError(true);
      } finally {
        setIsDone(true);
        setIsLoading(false);
      }
    },
    [depots, selectedAutoColumn, selectedDepot]
  );

  return {
    isLoading,
    isDone,
    hasError,
    exportPdf,
  };
}
